import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, Platform, ActivityIndicator, TouchableOpacity, Linking } from 'react-native';
import { Screen, Text, Button, Input, Icon, Line } from '../components';
import { HomePetsList } from '../containers';
import PetController from '../controllers/petController';
import AuthController from '../controllers/authController';
import UserController from '../controllers/userController';
import { useNavigate } from 'react-router-dom';

class SettingsContactSupportScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  async componentDidMount() {
    let user = await AuthController.getUser();

    if(user) {
      this.setState({

      })
    }
  }

  render() {

    return (
      <Screen navigation={this.props.navigation} title={'Contact Support'} style={{ backgroundColor: 'white' }}>
        <View style={{ padding: 20 }}>

          <TouchableOpacity style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}
                            onPress={ () => {
                              Linking.openURL('mailto:support@dodovet.com?subject=Technical%20Support%20/%20Feedback')
                            }}>
            <Text style={styles.row_title}>Technical Support / Feedback</Text>
          </TouchableOpacity>

          <Line style={{  }} />

          <TouchableOpacity style={{ paddingTop: 20, paddingBottom: 20, flexDirection: 'row', justifyContent: 'space-between' }}
                            onPress={ () => {
                              Linking.openURL('mailto:members@dodovet.com?subject=Modify%20Subscription')
                            }}>
            <Text style={styles.row_title}>Modify Subscription</Text>
          </TouchableOpacity>

          <Line style={{  }} />

        </View>
      </Screen>
    );
  }

}

function SettingsContactSupport(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <SettingsContactSupportScreen_Base {...props} navigate={navigate} />
  } else {
    return  <SettingsContactSupportScreen_Base {...props} navigate={props.navigation.push} />
  }
}

const styles = StyleSheet.create({
  error_message: {
    color: 'red'
  },
  row_title: {
    fontSize: 16,
    fontWeight: '500',
    color: '#040415'
  }
});

export default SettingsContactSupport
